import { differenceInYears } from "date-fns";
import { usePatient } from "src/context/PatientProvider";

export const usePatientAge = () => {
  const dob = usePatient((p) => p.profile.dob);

  if (dob == null) return 0;

  return differenceInYears(new Date(), new Date(dob));
};
